<template>
  <div>
    <b-card
      class="mb-0 text-center py-1"
      border-variant="primary"
    >
      <feather-icon
        icon="TrendingUpIcon"
        size="24"
        class="mb-1 text-primary"
      />
      <div class="font-weight-bold mb-50" style="font-size: 1.1rem;">
        Upgrade to Premium
      </div>
      <div class="text-muted mb-1 card-subtitle-wrap" style="font-size: 0.85rem;">
        Unlock advanced analytics and exclusive features
      </div>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        size="sm"
        to="/premium"
      >
        Learn More
      </b-button>
    </b-card>
  </div>
</template>

<script>
import { BCard, BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'UpgradeToPremium',
  components: {
    BCard,
    BButton,
  },
  directives: {
    Ripple,
  },
}
</script>
